import DateTime from 'utils/datetime';
import { CollectionStatus, HotcashTableColumn, PaymentRecord } from './types';

export const sortByPriority = (data: HotcashTableColumn[]) => {
  const sortPriority = {
    LATE: 1,
    LIVE: 2,
    SETTLED: 3,
  };

  return data?.sort((a, b) => {
    const priorityComparison =
      sortPriority[a?.status] - sortPriority[b?.status];

    // to sort the late payments from the most late to the less late
    if (priorityComparison === 0 && a?.status === 'LATE') {
      return (
        new Date(a?.startingTime)?.getTime() -
        new Date(b?.startingTime)?.getTime()
      );
    }

    return priorityComparison;
  });
};

export const formatPaymentRecords = (data: PaymentRecord[]) => {
  return sortByPriority(
    filterDuplicates(
      data?.map((record): HotcashTableColumn => {
        const now = DateTime.now();
        const allowedTimeForPayment = DateTime.add(record?.paidAt, 1, 'days');
        const isLive = DateTime.isBefore(now, allowedTimeForPayment);
        const isSettled = !!record?.settledAt;
        const isLate = DateTime.isBefore(allowedTimeForPayment, now);

        const timeLeft = allowedTimeForPayment;

        let status: CollectionStatus = 'LIVE';

        if (isLive && !isSettled) {
          status = 'LIVE';
        }

        if (isLate) {
          status = 'LATE';
        }

        if (isSettled) {
          status = 'SETTLED';
        }

        return {
          key: record?.id,
          id: record?.id,
          status,
          timeLeft,
          agronomistName: record?.cube?.rizeusersByFieldCoordinator?.name || '',
          cashHeld: record?.amount,
          currency: record?.currency,
          farmerName: record?.farmer?.name || '',
          invoiceNo: record?.description,
          paddyBuyerName: record?.paddyBuyer?.name || '',
          startingTime: record?.paidAt,
          settlingTime: record?.settledAt || undefined,
          paidBy: record?.paidBy,
        };
      }),
    ),
  );
};

export const filterDuplicates = (data: HotcashTableColumn[]) => {
  const tracker = new Set();

  return data?.filter((item) => {
    if (tracker.has(item?.id)) return false;
    else {
      tracker.add(item?.id);
      return true;
    }
  });
};
